import { SET_MFA_CHALLENGE, SET_MFA_STATUS } from "../actions/constants";

let initialState = {
  status: false,
  challenge: false,
  text: "",
  shouldDisplay: false
};

const mfa = (state = initialState, action) => {
  switch (action.type) {
    case SET_MFA_CHALLENGE:
      return { ...state, challenge: action.challenge, text: action.text, shouldDisplay: action.shouldDisplay };
    case SET_MFA_STATUS:
      return { ...state, status: action.status };
    default:
      return state;
  }
};

export default mfa;
